<script setup>
// The shortcode suggestions that surface as an agent types "/" in the composer.
// The shortcode being typed in the composer, sized to the `onboarding-typing`
// keyframe's 6ch reveal.
const TYPED_SHORTCODE = '/greet';

const SUGGESTIONS = [
  { id: 'greet', body: 'Good afternoon 👋, how can we help you?', delay: '' },
  {
    id: 'good-bye',
    body: 'Thank you, have a good day! ✌️',
    delay: '[animation-delay:0.18s]',
  },
];
</script>

<template>
  <div class="w-full px-5" aria-hidden="true">
    <div
      v-for="suggestion in SUGGESTIONS"
      :key="suggestion.id"
      class="px-3 py-2 mb-2 text-xs border rounded-lg shadow-lg opacity-0 bg-n-solid-1 border-n-weak text-n-slate-11 motion-safe:animate-onboarding-suggestion"
      :class="suggestion.delay"
    >
      <b class="font-semibold text-n-slate-12">{{ suggestion.id }}</b>
      · {{ suggestion.body }}
    </div>
    <div
      class="flex items-center gap-2 px-3 py-2.5 border rounded-xl bg-n-solid-1 border-n-weak"
    >
      <span
        class="overflow-hidden font-mono text-sm whitespace-nowrap text-n-slate-12 w-0 motion-safe:animate-onboarding-typing"
      >
        {{ TYPED_SHORTCODE }}
      </span>
      <span class="w-0.5 h-4 bg-n-brand motion-safe:animate-onboarding-caret" />
      <span
        class="grid ml-auto text-xs text-white rounded-md size-6 place-items-center bg-n-brand"
      >
        <span class="i-lucide-send size-3" />
      </span>
    </div>
  </div>
</template>
